export default __webpack_public_path__ + "media/packs/images/icons/fontawesome/ellipsis-h-30fc3bdc738120178ef2bbe5b53a2902.svg";